module.exports = __webpack_public_path__ + "static/img/yt@2x.94957f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yt@2x.png
// module id = W2N1
// module chunks = 2